<template>
  <div class="table-box">
    <global-tag>
      <el-form :inline="true" :model="searchlist" size="mini">
        <el-form-item label="菜单名称:">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model.trim="filterText"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin: 0">
          <el-button type="primary" icon="el-icon-search" @click="querySearch"
            >查询
          </el-button>
        </el-form-item>
      </el-form>
    </global-tag>

    <div class="three" style="margin-top: 12px">
      <el-button type="primary" size="mini" @click="showDialogForm(0, 0)"
        >新增模块
      </el-button>
    </div>
    <div class="table_card" style="margin-top: 6px">
      <el-table
        size="middle"
        :header-cell-style="{ background: '#f8fafa' }"
        align="center"
        current-row-key
        highlight-current-row
        height="40"
      >
        <el-table-column align="center" label="机构名称"></el-table-column>

        <el-table-column
          align="center"
          label="状态"
          width="100px"
        ></el-table-column>
        <el-table-column
          align="center"
          label="创建时间"
          width="140px"
        ></el-table-column>
        <el-table-column
          align="center"
          label="排序"
          width="80px"
        ></el-table-column>
        <el-table-column
          align="center"
          label="操作"
          width="240px"
        ></el-table-column>
      </el-table>
      <div v-if="openPanel">
        <el-tree
          ref="tree"
          class="filter-tree"
          :data="treedata"
          :props="defaultProps"
          node-key="id"
          :filter-node-method="filterNode"
          default-expand-all
          :expand-on-click-node="false"
          :render-content="renderContent"
        ></el-tree>
      </div>
    </div>
    <!-- 新增/修改弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="1000px"
      :before-close="clearadddata"
    >
      <el-form
        ref="addform"
        :rules="rules"
        :model="rowData"
        label-width="160px"
        size="mini"
      >
        <el-form-item label="机构上级：" prop="parentName">
          <el-input disabled v-model="rowData.parentName"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="18">
            <el-form-item label="类型:" prop="orgLevel">
              <el-select
                :disabled="editDisable"
                v-model="rowData.orgLevel"
                placeholder="--请选择--"
                style="width: 80%"
              >
                <el-option
                  v-for="item in orgTypes"
                  :key="item.value"
                  :disabled="item.disabled"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机构名称" prop="orgName">
              <el-input
                :disabled="editDisable"
                v-model.trim="rowData.orgName"
                placeholder="请输入机构名称"
                style="width: 80%"
              ></el-input>
            </el-form-item>
            <!-- @blur="searchAreaMap" -->
            <el-form-item label="排序：" prop="orgSort">
              <el-input-number
                controls-position="right"
                :min="1"
                v-model="rowData.orgSort"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align: right">
            <el-upload
              :action="baseUrl"
              :disabled="editDisable"
              :show-file-list="false"
              class="avatar-uploader"
              :on-success="
                (file, fileList) => {
                  handleAvatarSuccess(file, fileList)
                }
              "
            >
              <img v-if="rowData.photo" :src="rowData.photo" class="avatar" />
              <img v-else src="/logo.png" class="avatar" />
              <!-- <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
              ></i> -->
            </el-upload>
          </el-col>
        </el-row>

        <el-form-item v-if="editDisable" label="机构编码：" prop="orgCode">
          <el-input
            disabled
            v-model="rowData.orgCode"
            style="width: 70%"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="editDisable" label="创建时间：" prop="createDate">
          <el-input
            disabled
            v-model="rowData.createDate"
            style="width: 70%"
          ></el-input>
        </el-form-item>
        <div class="addressFrom">
          <div class="addressTitle"><span>*</span> 机构地址:</div>
          <div class="addressContent">
            <div class="addressBox">
              <div class="addressItem">
                <el-form-item>
                  <el-select
                    v-model="formData.rhPerson.provinceId"
                    placeholder="请选择省"
                    :disabled="
                      normalInfo.orgLevel == 1 ||
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5
                    "
                    @change="handleProvince"
                    style="width: 20%"
                    ref="selectShengChange"
                  >
                    <el-option
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item>
                  <el-select
                    v-model="formData.rhPerson.cityId"
                    placeholder="请选择市"
                    :disabled="
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5
                    "
                    @change="handleCity"
                    ref="selectShiChange"
                    style="width: 20%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item>
                  <el-select
                    v-model="formData.rhPerson.areaId"
                    :disabled="
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5
                    "
                    placeholder="请选择区"
                    @change="handleArea"
                    ref="selectQuChange"
                    style="width: 20%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item>
                  <el-select
                    v-model="formData.rhPerson.streetId"
                    :disabled="
                      normalInfo.orgLevel == 4 || normalInfo.orgLevel == 5
                    "
                    placeholder="请选择街道"
                    @change="streetChange"
                    style="width: 20%"
                    ref="selectJiedaoChange"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="addressItem">
                <el-form-item>
                  <el-select
                    v-model="formData.rhPerson.communityId"
                    :disabled="normalInfo.orgLevel == 5"
                    placeholder="请选择社区"
                    ref="selectShequChange"
                    style="width: 20%"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.addCode"
                      :label="item.addName"
                      :value="+item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="addressItem">
          <el-form-item>
            <el-select
              v-model="value"
              placeholder="请选择机构"
              style="margin-top: 15px"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-input
                v-model="formData.rhPerson.address"
                placeholder="请输入地址"
                style="margin-top: 20px"
            ></el-input> -->
          </el-form-item>
        </div>
        <el-form-item prop="address">
          <div class="posaddress">
            <input
              v-model.trim="formData.rhPerson.address"
              id="tipinput"
              class="el-input__inner"
              @focus="getMap('tipinput')"
              placeholder="请输入关键字"
              autocomplete="off"
            />
            <i
              class="el-icon-location-information colorIcon"
              @click="chioceDizhi"
            ></i>
          </div>
        </el-form-item>
        <div
          v-show="showmap"
          class="map_container"
          style="margin-bottom: 20px; overflow: hidden"
        >
          <div id="addressMap" style="width: 100%; height: 250px"></div>
        </div>
        <el-form-item label="网格区域：" prop="pointPosition" v-show="showmap">
          <mapbox
            v-if="mapOff"
            :orgId="rowData.id"
            :on-success="mapSuccess"
            :val="rowData.pointPosition"
            :mapCenter="mapCenter"
            style="width: 100%; height: 500px"
          ></mapbox>
        </el-form-item>
        <el-form-item label="网格颜色：" prop="gridColour" v-show="showmap">
          <el-color-picker v-model="rowData.gridColour"></el-color-picker>
        </el-form-item>
        <el-form-item label="状态：" prop="isValid">
          <el-radio-group v-model="rowData.isValid">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="boontbtn">
        <el-button
          type="primary"
          size="small"
          style="margin: 0 30px"
          @click="saveadddata('addform')"
          >保存
        </el-button>
        <el-button type="info" size="small" @click="clearadddata"
          >关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseURL from "@/api/baseURL"
import "@/assets/css/system.css"
import request from "../../../utils/request.js"
import ViewUser from "../dialog/userDialog.vue"
import mapbox from "./map"
import mapLoca from "./mapLoca"
// import AMap from "AMap"; // 引入高德地图
import moment from "moment"

export default {
  components: {
    ViewUser,
    mapbox,
    mapLoca,
  },
  data() {
    return {
      baseUrl: baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      showmap: false,
      marker: null, //地图标记点
      recMap: null,
      recIsMap: true,
      recPolygons: [],
      recPolygon: [],
      recMarker: null, //地图标记点
      options: [
        // {
        //     value: "花园机构",
        //     label: "花园机构",
        // },
        // {
        //     value: "明光机构",
        //     label: "明光机构",
        // },
      ],
      value: "",
      mapCenter: [],
      formData: {
        rhPerson: {
          provinceId: "",
          cityId: "",
          areaId: "",
          streetId: "",
          communityId: "",
          address: "",
        },

        personMember: [],
        personCaregivers: [],
        causesPoverty: {},
        socialAcvities: {},
        familyEconomic: {},
        familyIncome: {},
        otherInfo: {},
      },
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [],
      isdisabled: false,
      addressMap: null,
      areaMap: null,
      mapOff: false,
      searchlist: {},
      filterText: "",
      treedata: [],
      treeParentdata: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      orgTypes: [
        { value: "0", label: "总公司", disabled: false },
        { value: "1", label: "省级分公司", disabled: false },
        { value: "2", label: "市级分公司", disabled: false },
        { value: "3", label: "区县分公司", disabled: false },
        { value: "4", label: "街道分公司", disabled: false },
        { value: "5", label: "社区分公司", disabled: false },
      ],
      dialogTitle: "新增",
      flag: "add",
      showDialog: false,
      rowData: {
        gridOfficeName: "",
        isValid: "0",
        gridColour: "#409EFF",
      },
      gridOfficeName: "",
      showViewPeople: false,
      editDisable: false,
      rules: {
        orgName: [
          {
            required: true,
            message: "请输入机构名称",
            trigger: "blur",
          },
        ],
        // pointPosition: [
        //     {
        //         required: true,
        //         message: "请绘制地图",
        //         trigger: "change",
        //     },
        // ],
        isValid: [
          {
            required: true,
            message: "请选启动状态",
            trigger: "change",
          },
        ],
        orgLevel: [{ required: true, message: "请选类型", trigger: "change" }],
        orgSort: [
          {
            required: true,
            message: "请输入排序值",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0,
            message: "排序必须为数字值",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0,
            message: "排序必须为数字值",
            trigger: "change",
          },
        ],
      },
      //分级获取父类数据封装，暂时不用
      selectOrgs: [],
      parentIds: [],
      openPanel: true,
      normalInfo: {},
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    showDialog(val) {
      if (!val) {
        this.$refs["addform"].resetFields()
      }
    },
  },
  created() {
    this.getOrg()
  },
  methods: {
    // 上传照片
    handleAvatarSuccess(res, file) {
      if (res.code === 200 && res.content) {
        this.$set(this.rowData, "photo", res.content)
        console.log(this.rowData.photo, "------")
      }
    },
    //获取组织机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
          } else {
            this.$message.error(res.message)
          }
        })
    },

    querySearch() {
      this.getTreeDatas()
    },

    //根据地址信息渲染网格
    searchAreaMap() {
      let _this = this
      let str = _this.rowData.orgName
      if (!str) return
      _this.areaMap.clearMap()
      let opts = {
        subdistrict: 1, //返回下一级行政区
        extensions: "all",
        showbiz: false, //最后一级返回街道信息
      }

      str.replace(/(.+省|.+市|.+县|.+区)/g, ($1) => (str = $1))
      let district = new AMap.DistrictSearch(opts)
      district.search(str, (status, result) => {
        if (status == "complete") {
          let bounds = result.districtList[0].boundaries
          let polygon = []
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              polygon = new AMap.Polygon({
                map: _this.areaMap,
                strokeWeight: 1,
                strokeColor: "#007CDB",
                fillColor: "#2191E6",
                fillOpacity: 0.3,
                path: bounds[i],
              })
            }
          }
          _this.areaMap.add(polygon)
          _this.areaMap.setFitView() //地图自适应
        }
      })
    },

    //根据地址信息渲染标记点
    searchAddressInfo() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("addressMap", {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },

    mapSuccess(info) {
      console.log(info)
      this.rowData.pointPosition = info
    },
    mapSuccess2(info) {
      this.rowData.gridOfficeCordinate = info
      // 这里通过高德 SDK 完成。
      var geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: "all",
      })

      geocoder.getAddress(
        [info.split(",")[0], info.split(",")[1]],
        (status, result) => {
          if (status === "complete" && result.info === "OK") {
            if (result && result.regeocode) {
              this.rowData.gridOfficeName = result.regeocode.formattedAddress
            }
          }
        }
      )
    },
    //树形列表
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    //树形结果显示内容自定义
    renderContent(h, { node, data, store }) {
      data.time = moment(data.time).format("YYYY-MM-DD HH:mm:ss")
      return (
        <span class="tree-span">
          <span class="tree-span-label">
            <el-tag type={data.css} size="small">
              {data.tag}
            </el-tag>
            &nbsp;&nbsp;
            {node.label}
          </span>

          <span class="tree-span-status">
            <el-switch
              v-model={data.status}
              active-value="1"
              inactive-value="0"
              on-change={() => this.changeStatus(data)}
            ></el-switch>
          </span>
          <span class="tree-span-time">{data.time}</span>
          <span class="tree-span-sort">{data.sort}</span>
          <span class="tree-span-button">
            {data.tag != "社区" ? (
              <el-button
                size="mini"
                type="primary"
                on-click={() => this.showDialogForm(0, data.id, data)}
              >
                新增下级
              </el-button>
            ) : (
              ""
            )}

            <el-button
              size="mini"
              type="success"
              on-click={() => this.showDialogForm(data.id, data.parentId)}
            >
              编辑
            </el-button>
            <el-button
              size="mini"
              type="danger"
              on-click={() => this.showdeletepanduan(data.id)}
            >
              删除
            </el-button>
          </span>
        </span>
      )
    },
    async getTreeDatas() {
      var res = await request({
        url: "/rbac/admin/org/info/OrgTreelist",
        method: "POST",
        data: {},
        //  data: { orgType: "1" }
      })
      if (res.content && res.content.length > 0) {
        this.treedata = []
        this.treeParentdata = []
        res.content.forEach((item) => {
          var children = []
          if (item.children != null && item.children.length > 0) {
            children = this.formateTree(item.children)
          }
          //0.省级 1.市级 2.区县 3.站点
          var tag = ""
          var css = ""
          if (item.orgLevel == "0") {
            tag = "顶级"
            css = "success"
          } else if (item.orgLevel == "1") {
            tag = "省级"
            css = "danger"
          } else if (item.orgLevel == "2") {
            tag = "市级"
            css = ""
          } else if (item.orgLevel == "3") {
            tag = "区县"
            css = "info"
          } else if (item.orgLevel == "4") {
            tag = "街道"
            css = "warning"
          } else if (item.orgLevel == "5") {
            tag = "社区"
            css = "warning"
          }

          this.treedata.push({
            id: item.orgId,
            code: item.orgCode,
            tag: tag,
            css: css,
            sort: item.orgSort,
            status: String(item.isValid),
            time: item.createDate,
            parentId: item.parentId,
            value: item.id,
            label: item.label,
            children: children,
          })
        })

        this.selectOrgs = this.treedata
        this.$forceUpdate()
      }
    },
    formateTree(arr) {
      var temp = []
      if (arr.length > 0) {
        arr.forEach((item) => {
          var children = []
          if (item.children != null && item.children.length > 0) {
            children = this.formateTree(item.children)
          }
          var tag = ""
          var css = ""
          if (item.orgLevel == "0") {
            tag = "顶级"
            css = "success"
          } else if (item.orgLevel == "1") {
            tag = "省级"
            css = "danger"
          } else if (item.orgLevel == "2") {
            tag = "市级"
            css = ""
          } else if (item.orgLevel == "3") {
            tag = "区县"
            css = "info"
          } else if (item.orgLevel == "4") {
            tag = "街道"
            css = "warning"
          } else if (item.orgLevel == "5") {
            tag = "社区"
            css = "warning"
          } else if (item.orgLevel == "6") {
            tag = "网格"
            css = "warning"
          }

          temp.push({
            id: item.orgId,
            code: item.orgCode,
            tag: tag,
            css: css,
            sort: item.orgSort,
            status: item.isValid + "",
            time: item.createDate,
            parentId: item.parentId,
            value: item.id,
            label: item.label,
            children: children,
          })
        })
      }
      return temp
    },
    // 取消
    clearadddata() {
      this.showDialog = false
      this.showmap = false
      this.orgTypes = [
        { value: "0", label: "总公司", disabled: false },
        { value: "1", label: "省级分公司", disabled: false },
        { value: "2", label: "市级分公司", disabled: false },
        { value: "3", label: "区县分公司", disabled: false },
        { value: "4", label: "街道分公司", disabled: false },
        { value: "5", label: "社区分公司", disabled: false },
        { value: "6", label: "网格分公司", disabled: false },
      ]

      this.$refs.addform.resetFields()
      this.formData = {
        rhPerson: {
          provinceId: "",
          cityId: "",
          areaId: "",
          streetId: "",
          communityId: "",
          address: "",
        },
        personMember: [],
        personCaregivers: [],
        causesPoverty: {},
        socialAcvities: {},
        familyEconomic: {},
        familyIncome: {},
        otherInfo: {},
      }
      // this.rowData.orgLevel = "0"
    },
    //新增框 带着父类id
    async showDialogForm(id, pId, data) {
      this.isdisabled = false
      this.showDialog = true
      this.mapOff = false
      this.rowData.pointPosition = ""
      this.rowData.isValid = "1"
      // this.loadAreaMap();
      // this.rowData.gridColour ? "#" + this.rowData.gridColour : this.rowData.gridColour;
      if (id > 0) {
        this.dialogTitle = "编辑"
        var res = await request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: JSON.stringify({ id: id }),
        })
        if (res.code == 200) {
          res.content.orgLevel = String(res.content.orgLevel)
          this.rowData = res.content
          this.formData.rhPerson.address = res.content.address
          res.content.provinceId = res.content.provinceId
            ? String(res.content.provinceId)
            : ""
          res.content.cityId = res.content.cityId
            ? String(res.content.cityId)
            : ""
          res.content.areaId = res.content.areaId
            ? String(res.content.areaId)
            : ""
          res.content.provinceId = res.content.provinceId
            ? String(res.content.provinceId)
            : ""
          res.content.streetId = res.content.streetId
            ? String(res.content.streetId)
            : ""
          res.content.communityId = res.content.communityId
            ? Number(res.content.communityId)
            : ""
          res.content.orgSort = Number(res.content.orgSort)
          this.formData.rhPerson.provinceId = res.content.provinceId
          this.formData.rhPerson.cityId = res.content.cityId
          this.formData.rhPerson.areaId = res.content.areaId
          this.formData.rhPerson.streetId = res.content.streetId
          this.formData.rhPerson.communityId = Number(res.content.communityId)
          if (this.formData.rhPerson.communityId == 0) {
            this.formData.rhPerson.communityId = ""
          }
          if (!this.formData.rhPerson.provinceId) return
          let city = await this.getDistrict(this.formData.rhPerson.provinceId)
          this.cityList = city.districtList
          console.log(this.cityList, "this.cityList")
          if (!this.formData.rhPerson.cityId) return
          let area = await this.getStreetList(this.formData.rhPerson.cityId)
          this.areaList = area
          if (!this.formData.rhPerson.areaId) return
          let street = await this.getStreetList(this.formData.rhPerson.areaId)
          this.streetList = street
          if (!this.formData.rhPerson.streetId) return
          let communityList = await this.getStreetList(
            this.formData.rhPerson.streetId
          )

          this.communityList = communityList

          this.formData.rhPerson.longitude = res.content.longitude
          this.formData.rhPerson.latitude = res.content.latitude
          if (!this.formData.rhPerson.latitude) {
            if (
              this.formData.rhPerson.streetId &&
              this.formData.rhPerson.provinceId &&
              this.formData.rhPerson.cityId &&
              this.formData.rhPerson.areaId
            ) {
              this.streetList.forEach((item, index) => {
                if (item.addCode == this.formData.rhPerson.streetId) {
                  this.formData.rhPerson.latitude = item.latitude
                  this.formData.rhPerson.longitude = longitude
                }
              })
            } else {
              if (
                this.formData.rhPerson.provinceId &&
                this.formData.rhPerson.cityId &&
                this.formData.rhPerson.areaId
              ) {
                // this.areaList.forEach((item) => {
                //   if (item.adcode == this.formData.rhPerson.areaId) {
                //     this.formData.rhPerson.latitude = item.center.lat
                //     this.formData.rhPerson.longitude = item.center.lng
                //   }
                // })
              } else {
                if (
                  this.formData.rhPerson.provinceId &&
                  this.formData.rhPerson.cityId
                ) {
                  this.cityList.forEach((item) => {
                    if (item.adcode == this.formData.rhPerson.cityId) {
                      this.formData.rhPerson.latitude = item.center.lat
                      this.formData.rhPerson.longitude = item.center.lng
                    }
                  })
                } else {
                  this.provinceList.forEach((item) => {
                    if (item.adcode == this.formData.rhPerson.provinceId) {
                      this.formData.rhPerson.latitude = item.center.lat
                      this.formData.rhPerson.longitude = item.center.lng
                    }
                  })
                }
              }
            }
          }
          this.mapCenter = [
            this.formData.rhPerson.longitude,
            this.formData.rhPerson.latitude,
          ]
          this.mapOff = true
          if (this.rowData.orgLevel == "0") {
            this.rowData.orgLevelName = "省级分公司"
          } else if (this.rowData.orgLevel == "1") {
            this.rowData.orgLevelName = "市级分公司"
          } else if (this.rowData.orgLevel == "2") {
            this.rowData.orgLevelName = "区县分公司"
          } else if (this.rowData.orgLevel == "3") {
            this.rowData.orgLevelName = "街道分公司"
          } else if (this.rowData.orgLevel == "4") {
            this.rowData.orgLevelName = "社区分公司"
          }
          this.searchAddressInfo()
          if (
            this.formData.rhPerson.longitude &&
            this.formData.rhPerson.latitude
          ) {
            setTimeout(() => {
              this.potintMap()
            }, 500)
          }
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        } else {
          this.$message({
            message: "数据项加载异常",
            type: "error",
          })
          this.showDialog = false
        }
      } else {
        this.dialogTitle = "新增"
        this.rowData = {}
        this.rowData.isValid = 1
        this.mapOff = false
        this.changeFirst()
        if (pId > 0) {
          var res = await request({
            url: "/rbac/admin/org/info/findOrgById",
            method: "POST",
            data: JSON.stringify({ id: pId }),
          })
          if (res.code == 200) {
            if (res.content != null) {
              this.rowData.parentId = res.content.id
              this.rowData.parentName = res.content.orgName
            }
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          } else {
            this.$message({
              message: "父类数据项加载异常",
              type: "error",
            })
          }
        } else {
          this.rowData.parentId = 0
          this.rowData.parentName = "无父类"
        }
        if (!data) {
          this.orgTypes = [
            { value: "0", label: "总公司", disabled: false },
            { value: "1", label: "省级分公司", disabled: true },
            { value: "2", label: "市级分公司", disabled: true },
            { value: "3", label: "区县分公司", disabled: true },
            { value: "4", label: "街道分公司", disabled: true },
            { value: "5", label: "社区分公司", disabled: true },
          ]
        }
        if (data) {
          if (data.tag == "顶级") {
            this.orgTypes = [
              { value: "0", label: "总公司", disabled: true },
              {
                value: "1",
                label: "省级分公司",
                disabled: false,
              },
              {
                value: "2",
                label: "市级分公司",
                disabled: false,
              },
              {
                value: "3",
                label: "区县分公司",
                disabled: false,
              },
              {
                value: "4",
                label: "街道分公司",
                disabled: false,
              },
              {
                value: "5",
                label: "社区分公司",
                disabled: false,
              },
            ]
          }
          if (data.tag == "省级") {
            this.orgTypes = [
              { value: "0", label: "总公司", disabled: true },
              { value: "1", label: "省级分公司", disabled: true },
              {
                value: "2",
                label: "市级分公司",
                disabled: false,
              },
              {
                value: "3",
                label: "区县分公司",
                disabled: false,
              },
              {
                value: "4",
                label: "街道分公司",
                disabled: false,
              },
              {
                value: "5",
                label: "社区分公司",
                disabled: false,
              },
            ]
          } else if (data.tag == "市级") {
            this.orgTypes = [
              { value: "0", label: "总公司", disabled: true },
              { value: "1", label: "省级分公司", disabled: true },
              { value: "2", label: "市级分公司", disabled: true },
              {
                value: "3",
                label: "区县分公司",
                disabled: false,
              },
              {
                value: "4",
                label: "街道分公司",
                disabled: false,
              },
              {
                value: "5",
                label: "社区分公司",
                disabled: false,
              },
            ]
          } else if (data.tag == "区县") {
            this.orgTypes = [
              { value: "0", label: "总公司", disabled: true },
              { value: "1", label: "省级分公司", disabled: true },
              { value: "2", label: "市级分公司", disabled: true },
              { value: "3", label: "区县分公司", disabled: true },
              {
                value: "4",
                label: "街道分公司",
                disabled: false,
              },
              {
                value: "5",
                label: "社区分公司",
                disabled: false,
              },
            ]
          } else if (data.tag == "街道") {
            this.orgTypes = [
              { value: "0", label: "总公司", disabled: true },
              { value: "1", label: "省级分公司", disabled: true },
              { value: "2", label: "市级分公司", disabled: true },
              { value: "3", label: "区县分公司", disabled: true },
              { value: "4", label: "街道分公司", disabled: true },
              {
                value: "5",
                label: "社区分公司",
                disabled: false,
              },
            ]
          } else if (data.tag == "社区") {
            this.orgTypes = [
              { value: "0", label: "总公司", disabled: true },
              { value: "1", label: "省级分公司", disabled: true },
              { value: "2", label: "市级分公司", disabled: true },
              { value: "3", label: "区县分公司", disabled: true },
              { value: "4", label: "街道分公司", disabled: true },
              { value: "5", label: "社区分公司", disabled: true },
            ]
          }
        }
        // this.showDialog = true;
        // this.init();
      }
    },
    chioceDizhi() {
      this.showmap = !this.showmap
    },
    //获取新增所有数据发请求
    saveadddata(fromdate) {
      console.log(fromdate)
      this.isdisabled = true
      this.$refs[fromdate].validate((valid) => {
        if (valid) {
          if (
            !this.formData.rhPerson.provinceId &&
            this.rowData.orgLevel == 0
          ) {
            this.isdisabled = true
            this.$message.error("省级地址为必填项，请选择")
            this.isdisabled = false
            return
          }
          if (
            !this.formData.rhPerson.provinceId &&
            this.rowData.orgLevel == 1
          ) {
            this.isdisabled = true
            this.$message.error("省级地址为必填项，请选择")
            this.isdisabled = false
            return
          }
          if (!this.formData.rhPerson.cityId && this.rowData.orgLevel == 2) {
            this.$message.error("市级地址为必填项，请选择")
            this.isdisabled = false
            return
          }
          if (!this.formData.rhPerson.areaId && this.rowData.orgLevel == 3) {
            this.$message.error("区县级地址为必填项，请选择")
            this.isdisabled = false
            return
          }
          if (!this.formData.rhPerson.streetId && this.rowData.orgLevel == 4) {
            this.$message.error("街道地址为必填项，请选择")
            this.isdisabled = false
            return
          }
          this.rowData.orgType = "1"
          this.rowData.provinceId = this.formData.rhPerson.provinceId
          this.rowData.cityId = this.formData.rhPerson.cityId
          this.rowData.areaId = this.formData.rhPerson.areaId
          this.rowData.streetId = this.formData.rhPerson.streetId
          this.rowData.latitude = this.formData.rhPerson.latitude
          this.rowData.longitude = this.formData.rhPerson.longitude
          this.rowData.communityId = this.formData.rhPerson.communityId
          this.rowData.address = this.formData.rhPerson.address
          if (this.mapOff == true) {
            if (
              this.rowData.pointPosition == "" ||
              this.rowData.pointPosition == undefined
            ) {
            //  this.$message.warning("请绘制区域地图")
             // return
            }
          }
          //提交选择的机构
          this.rowData.service = this.value
          let params = JSON.stringify(this.rowData)
          console.log(params, "pppp")
          let url = "/rbac/admin/org/info/insert"
          if (this.rowData.id != undefined) {
            url = "/rbac/admin/org/info/update"
          }
          this.openPanel = false
          request({
            url: url,
            method: "POST",
            data: params,
          })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: this.dialogTitle + "成功",
                  type: "success",
                })
                this.showDialog = false
                this.isdisabled = false
                this.getTreeDatas()
                this.openPanel = true
                this.$refs[formName].resetFields()
              } else if (res.code == "10004") {
                this.openPanel = true
                this.$message.error(res.message)
                this.isdisabled = false
                this.$router.push("/login")
              } else {
                this.isdisabled = false
                this.openPanel = true
                this.$message({
                  message: this.dialogTitle + "失败：" + res.message,
                  type: "error",
                })
              }
            })
            .catch((err) => {
              this.openPanel = true
              this.showDialog = false
            })
        } else {
          this.isdisabled = false
          this.openPanel = true
        }
      })
    },
    //改变状态
    async changeStatus(cdata) {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgByRoles",
          method: "POST",
          data: { id: cdata.id },
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.content == null) {
              let params = JSON.stringify({
                id: cdata.id,
                isValid: cdata.status,
              })

              var res = request({
                url: "/rbac/admin/org/info/update",
                method: "POST",
                data: params,
              })

              var msg = "机构-" + cdata.label + "，状态"
              msg = msg + (cdata.status == "1" ? "启用" : "禁用")
              if (res.code == 200) {
                this.$message({
                  message: msg + "成功",
                  type: "success",
                })
              } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
                this.getTreeDatas()
              }
              //   else {
              //     this.$message({
              //       message: msg + "失败：", //+ res.message
              //       type: "error",
              //     });
              //     this.getTreeDatas();
              //   }
            } else {
              this.$message.error("该机构存在关联数据当前不可禁用")
              this.getTreeDatas()
            }
            console.log(res.content, "wwww")
          } else {
            this.getTreeDatas()
          }
        })
      // .catch(() => {
      //   this.getTreeDatas();
      // });
    },

    //删除操作
    async showdeletepanduan(id) {
      let ab = null
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgByRoles", ///rbac/admin/org/info/findOrgAndChildById
          method: "POST",
          data: {
            id: id,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            console.log(res.content, "content")
            if (res.content != null) {
              this.$message.error("该机构存在数据使用，当前不可删除")
            } else {
              this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(async () => {
                  let params = JSON.stringify({ id: id })
                  var res = await request({
                    url: "/rbac/admin/org/info/deleteOrg",
                    method: "POST",
                    data: params,
                  })
                  if (res.code == 200) {
                    this.$message({
                      message: "删除成功",
                      type: "success",
                    })
                    this.getTreeDatas()
                  } else {
                    this.$message({
                      message: "删除失败：" + res.message,
                      type: "error",
                    })
                  }
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消删除",
                  })
                })
            }
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },
    //省级地址改变
    async handleProvince(val) {
      if (this.dialogTitle == "新增") {
        this.mapOff = false
      }
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.rhPerson.areaId = ""
      this.formData.rhPerson.streetId = ""
      this.formData.rhPerson.communityId = ""
      this.formData.rhPerson.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //市级实居住地址发生改变
    async handleCity(val) {
      if (this.dialogTitle == "新增") {
        this.mapOff = false
      }
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.rhPerson.areaId = ""
      this.formData.rhPerson.streetId = ""
      this.formData.rhPerson.communityId = ""
      this.formData.rhPerson.address = ""
      let area = await this.getStreetList(val)
      this.areaList = area
      this.joinAddress()
    },
    //县区级实居住地址发生改变
    async handleArea(val) {
      if (this.dialogTitle == "新增") {
        this.mapOff = false
      }
      this.streetList = []
      this.communityList = []
      this.formData.rhPerson.streetId = ""
      this.formData.rhPerson.communityId = ""
      this.formData.rhPerson.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getStreetList(val)
      this.streetList = street
      this.joinAddress()
    },
    async changeFirst() {
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistrict(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getStreetList(this.normalInfo.cityId)
        this.areaList = areaList
        console.log(this.areaList, "uq")
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getStreetList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.formData.rhPerson.latitude = item.center.lat
            this.formData.rhPerson.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.formData.rhPerson.latitude = item.center.lat
            this.formData.rhPerson.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        // this.areaList.forEach((item) => {
        //   if (item.adcode == this.normalInfo.areaId) {
        //     this.formData.rhPerson.latitude = item.center.lat
        //     this.formData.rhPerson.longitude = item.center.lng
        //   }
        // })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.addCode == this.normalInfo.streetId) {
            this.formData.rhPerson.latitude = item.latitude
            this.formData.rhPerson.longitude = item.longitude
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.formData.rhPerson.provinceId = this.normalInfo.provinceId
      this.formData.rhPerson.cityId = this.normalInfo.cityId
      this.formData.rhPerson.areaId = this.normalInfo.areaId
      this.formData.rhPerson.streetId = this.normalInfo.streetId
      this.formData.rhPerson.communityId = this.normalInfo.communityId
      this.mapCenter = [
        this.formData.rhPerson.longitude,
        this.formData.rhPerson.latitude,
      ]
      this.mapOff = true
      this.searchAddressInfo()
      setTimeout(() => {
        this.potintMap()
      }, 500)
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 打点
    potintMap() {
      const self = this
      // self.myMap.remove(self.marker);
      if (self.marker) {
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(this.formData.rhPerson.longitude),
          Number(this.formData.rhPerson.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
      // if (self.dialogTitle == "新增") {
      self.mapCenter = [
        self.formData.rhPerson.longitude,
        self.formData.rhPerson.latitude,
      ]
      // self.mapOff = true
      // }
      // console.log(this.addForm.latitude, this.addForm.longitude, "坐标系")
    },
    //街道地址发生变化
    async streetChange(val) {
      if (this.dialogTitle == "新增") {
        this.mapOff = false
      }
      this.formData.rhPerson.communityId = ""
      this.formData.rhPerson.address = ""
      let communityList = await this.getStreetList(val)
      this.communityList = communityList
      this.joinAddress()
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    //社区实居住地址发生变化
    handleCommunityChange(val) {
      if (this.dialogTitle == "新增") {
        this.mapOff = false
      }
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    // 输入地址
    getMap(input) {
      const self = this

      const autoOptions = {
        city: self.formData.rhPerson.areaId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.rhPerson.address = e.poi.name
        self.formData.rhPerson.longitude = e.poi.location.lng
        self.formData.rhPerson.latitude = e.poi.location.lat
        // self.mapOff = false
        self.potintMap()
        self.$forceUpdate()
      })
    },

    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          // console.log(err);
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        console.log(
          shengName + shiName + quName + jiedaoName + shequName,
          "111"
        )
        if (!address) {
          self.formData.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.formData.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData.rhPerson.longitude = lnglat.lng
            self.formData.rhPerson.latitude = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
            // if (self.dialogTitle == "新增") {
            self.mapCenter = [
              self.formData.rhPerson.longitude,
              self.formData.rhPerson.latitude,
            ]
            // self.mapOff = true
            // }
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
  },
  mounted() {
    this.getProvince()
    this.getTreeDatas()
  },
}
</script>
<style lang="less" scoped>
// 深度穿透样式
/deep/ .el-tree-node__content {
  border: 1px solid #ebeef5 !important;
  border-top: 0px;
  height: 40px;
  line-height: 40px;
}

/deep/ .tree-span {
  font-size: 13px;

  .tree-span-code {
    position: absolute;
    right: 570px;
    width: 120px;
    text-align: center;
  }

  .tree-span-status {
    position: absolute;
    right: 470px;
    width: 100px;
    text-align: center;
  }

  .tree-span-time {
    position: absolute;
    right: 330px;
    width: 140px;
    text-align: center;
  }

  .tree-span-sort {
    position: absolute;
    right: 250px;
    width: 80px;
    text-align: center;
  }

  .tree-span-button {
    position: absolute;
    right: 10px;
    width: 240px;
    text-align: center;
  }
}

.posaddress {
  position: relative;

  i {
    position: absolute;
    right: 20px;
    color: #0000ff;
    font-size: 28px;
    top: 7px;
  }
}

.addressFrom {
  display: flex;
  margin-left: 73px;
  height: 30px;

  .addressTitle {
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 30px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .addressContent {
    flex: 1;

    .addressBox {
      display: flex;

      .addressItem {
        flex: 1;

        /deep/ .el-form-item__content {
          margin-left: 0px !important;
        }

        /deep/ .el-select {
          width: 100% !important;
        }
      }
    }

    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    // text-align: right;
  }
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
